module.exports = __webpack_public_path__ + "img/color-picker.4b4c358d.svg";